import * as streamActions from '../store/actions/InterviewRecordingActions';

/**
 * Checks if an element is fully visible within its scrollable container
 * @param {HTMLElement} element - The element to check for visibility
 * @returns {boolean} - True if the element is fully visible, false otherwise
 */
export const isElementFullyVisible = element => {
  if (!element) return false;

  const rect = element.getBoundingClientRect();
  const parentRect = element.parentElement.parentElement.getBoundingClientRect();

  return (
    rect.top >= parentRect.top &&
    rect.bottom <= parentRect.bottom &&
    rect.left >= parentRect.left &&
    rect.right <= parentRect.right
  );
};

/**
 * Scrolls an element into view only if it's not already fully visible
 * @param {HTMLElement} element - The element to scroll into view
 */
export const scrollIntoViewIfNeeded = element => {
  if (!element) return;

  if (!isElementFullyVisible(element)) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }
};

const totalTimer = data =>
  (data.total_time > 0
    ? data.total_time
    : data.sections_info?.reduce((sum, sec) => sec.total_time + sum, 0)) || 0;

export const sectionInfoSerializer = data => {
  return {
    loading: false,
    title: data.title || '',
    instructions: data.instructions || '',
    totalTime: totalTimer(data),
    totalProblems: data.total_problems || 0,
    totalMcqs: data.total_mcqs || 0,
  };
};

export const leaveMeeting = async (meetingSession, dispatch) => {
  if (!meetingSession) return;

  try {
    const { audioVideo } = meetingSession;

    if (audioVideo.stopVideoInput) {
      await audioVideo.stopVideoInput();
    }

    if (audioVideo.stopAudioInput) {
      await audioVideo.stopAudioInput();
    }

    try {
      await audioVideo.stopContentShare();
    } catch (err) {
      console.warn('[Chime] Content share cleanup skipped:', err);
    }

    audioVideo.stop();

    if (audioVideo.realtimeUnsubscribeFromAllEvents) {
      audioVideo.realtimeUnsubscribeFromAllEvents();
    }

    dispatch(streamActions.stopAllStreams());
    console.log('Left meeting and cleaned up');
  } catch (err) {
    console.error('Error while leaving meeting:', err);
  }
};
